export default __webpack_public_path__ + "static/media/information--motorway-exit-ahead--g3.8af9ebcc.png";